import products from "./products";
import brands from "./brands";
import currencies from "./currencies";
import copy from "./copy";

var urlParams = window.location.search.substr(1).split('&').reduce(function (q, query) {
    var chunks = query.split('=');
    var key = chunks[0];
    var value = chunks[1];
    return (q[key] = value, q);
}, {});

let locale = urlParams.locale ? urlParams.locale : "en";
const journey = urlParams.journey;

const productsById = products.reduce((acc, next) => {
    acc[next.id] = next;
    return acc;
}, {});

const brandsById = brands.reduce((acc, next) => {
    acc[next.id] = next;
    return acc;
}, {});

const setLocale = _locale => {
    locale = _locale;
};

const getLocale = () => locale;

export default {
    products,
    copy(key) {
        return copy[locale][key];
    },
    productsById,
    brandsById,
    currencies,
    setLocale,
    getLocale,
    journey: journey
};



// WEBPACK FOOTER //
// ./src/data/index.js